/**
 * Browse By Block Toggle Handler
 * 
 * Manages radio button behavior for browse-by dropdowns, allowing:
 * - Mutual exclusivity (only one dropdown open at a time)
 * - Toggle-to-close functionality (clicking the same button closes it)
 */

function initializeBrowseByToggles(): void {
  // Handle mobile toggles
  const mobileLabels = document.querySelectorAll<HTMLLabelElement>('.browse-by-mobile label[for]');
  let lastMobileChecked: HTMLInputElement | null = null;

  mobileLabels.forEach(label => {
    label.addEventListener('click', function(e) {
      const targetId = this.getAttribute('for');
      if (!targetId) return;
      
      const targetInput = document.getElementById(targetId) as HTMLInputElement;
      if (!targetInput) return;
      
      if (targetInput === lastMobileChecked && targetInput.checked) {
        e.preventDefault();
        targetInput.checked = false;
        lastMobileChecked = null;
      } else {
        lastMobileChecked = targetInput;
      }
    });
  });

  // Handle desktop toggles
  const desktopLabels = document.querySelectorAll<HTMLLabelElement>('.browse-by-desktop label[for]');
  let lastDesktopChecked: HTMLInputElement | null = null;

  desktopLabels.forEach(label => {
    label.addEventListener('click', function(e) {
      const targetId = this.getAttribute('for');
      if (!targetId) return;
      
      const targetInput = document.getElementById(targetId) as HTMLInputElement;
      if (!targetInput) return;
      
      if (targetInput === lastDesktopChecked && targetInput.checked) {
        e.preventDefault();
        targetInput.checked = false;
        lastDesktopChecked = null;
      } else {
        lastDesktopChecked = targetInput;
      }
    });
  });
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeBrowseByToggles);
} else {
  initializeBrowseByToggles();
}
